( function( $, document, window ) {
	'use strict';

	const $gated_btn = $( '.js-gated-link' );
	let link = '';

	$gated_btn.on( 'click', function() {
		link = $( this ).attr( 'href' );
		console.log( link );
	});


	// 2. Listen for Gravity Forms to submit successfully via AJAX
	$(document).on('gform_confirmation_loaded', function(event, formId) {

		// Verify the confirmation message is actually inside the open fancyBox
		let confirmationWrapper = $('.fancybox-content').find('.gform_confirmation_wrapper');

		if (confirmationWrapper.length) {
			console.log( link );

			// Trigger the PDF download in a new tab
			if (link) {
				window.open(link, '_blank');
			}

			// Fallback in case new tab doesn't open
			let confirmationBox = $('.js-gated-modal').find('.gform_confirmation_message');

			// Append a styled button directly below the success message text
			confirmationBox.html(`
                <div class="modal__content modal__content--fallback  copy copy--size_sm">
                    <p>Your download should begin automatically. If not, please click the button below: </p>
                    <a href="${link}" target="_blank" class="btn">Open PDF Download</a>
                </div>
            `);
		}
	});






} )( jQuery, document, window );
